import { DataType } from '@labrav/react-components/lib/@types/types/forms'

export const formFields = {
  multiselect: {
    title: 'Microsoft partner type',
    placeHolder: 'Enter one or more Partner Type',
    humanReadableKey: 'microsoftPartnerType',
    id: 'microsoftPartnerType',
    isReadOnly: false,
    isRequired: true,
    defaultValue: undefined,
    dataType: 'multi_enum' as DataType,
    validationType: undefined,
    isCustom: false,
    options: [
      'Managed Service Provider',
      'Cloud Solution Provider',
      'Reseller or Distributor',
      'Systems Integrator, Sl or Consultant',
      'Original Equipment',
      'Manufacturer, OEM',
      'Consumer Developer',
    ],
  },
  select: {
    title: 'Industries',
    placeHolder: 'Enter type of Industry',
    humanReadableKey: 'industries',
    id: 'industries',
    isReadOnly: false,
    isRequired: true,
    defaultValue: undefined,
    dataType: 'enum' as DataType,
    validationType: undefined,
    isCustom: false,
    options: [
      'Digital Media',
      'Education',
      'Financial Services',
      'Government',
      'Healthcare',
      'Industrial Software',
      'Life Sciences',
      'Nonprofit',
      'Public Safety and Disaster Response',
      'Retail',
      'Travel And Hospitality',
    ],
    info: 'How does the customer sells or have their products handed to their customers.',
  },
}
